<template>
    <v-toolbar dark color="primary" height="80">
        <v-btn @click="goBack('units')" icon text>
            <v-icon>arrow_back</v-icon>
        </v-btn>
        <div class="gk-toolbar-title">
            <div class="unit-logo mx-4">
                <v-icon>local_shipping</v-icon>
            </div>

            <template v-if="unit">
                <div class="unit-number">
                    <span class="title">{{ unit.number }} {{ deleted }} {{ department }}</span>
                </div>
                <div class="unit-name">
                    <span class="subtitle-1">{{ unit.name }} {{ configTitle }}</span>
                </div>
                <div class="unit-garage">
                    <span class="subtitle-1 white&#45;&#45;text">{{ unit.garage }}</span>
                </div>
                <div class="vehicle-details">
                    <span class="subtitle-2">{{ subTitle }}</span>
                </div>
            </template>
        </div>
    </v-toolbar>
</template>

<script>
import Back from '../Back.vue';

export default {
    props: { unit: { required: true } },
    name: 'VehicleToolbar',
    mixins: [Back],
    computed: {
        unitId() {
            return this.$route.params.unitId;
        },
        department() {
            if (!this.unit.department) {
                return '';
            }
            return `(${this.unit.department})`;
        },
        deleted() {
            if (!this.unit.isDeleted) {
                return '';
            }
            return `(DELETED)`;
        },
        configTitle() {
            if (!this.unit.chassisConfiguration && !this.unit.bodyConfiguration) {
                return;
            }
            const configs = [];
            if (!!this.unit.chassisConfiguration) {
                configs.push(this.unit.chassisConfiguration.name);
            }
            if (!!this.unit.bodyConfiguration) {
                configs.push(this.unit.bodyConfiguration.name);
            }

            return `- ${configs.join(' - ')}`;
        },
        subTitle() {
            let subTitleString = 'VIN - ' + this.unit.vin + '   Rego\xa0-\xa0' + this.unit.registrationNumber + '   Engine#\xa0-\xa0' + this.unit.engineNumber;

            if (this.unit.activityName) {
                subTitleString += '   ' + this.unit.activityName;
            }
            if (this.unit.installationAddress) {
                subTitleString += '   Address\xa0-\xa0' + this.unit.installationAddress;
            }

            return subTitleString;
        }
    }
};
</script>
<style lang="scss" scoped>
/*copied from v-toolbar__title*/
.gk-toolbar-title {
    font-size: 1.25rem;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    display: grid;
    grid-template:
        'logo number name'
        'logo garage vehicle-details';
    grid-template-columns: auto auto 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 0 20px;

    > * {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .unit-logo {
        grid-area: logo;
        align-self: center;
    }
    .unit-number {
        grid-area: number;
    }
    .unit-name {
        grid-area: name;
    }
    .unit-garage {
        grid-area: garage;
        color: rgba(255, 255, 255, 0.7);
    }
    .vehicle-details {
        grid-area: vehicle-details;
        color: rgba(255, 255, 255, 0.7);
    }
}
</style>
